// src/components/layout/Header.js
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Container,
  Offcanvas,
  Form,
  Button,
  Nav,
  Navbar,
  NavDropdown,
  Modal,
} from "react-bootstrap";
import { useNavigate, Link, NavLink } from "react-router-dom";
import { useAuth } from "../../shared/auth/AuthProvider";
import "../styles/Header.css";

import { BsSearch, BsChevronRight } from "react-icons/bs";

import logo_header_01 from "../../assets/logo_header_01.png";
import Logo_Header_02 from "../../assets/Logo_Encraft_02.png";

/* function Avatar({ user, profile, size = 36 }) {
  const initial = (
    user?.displayName?.trim()?.[0] ??
    user?.email?.trim()?.[0] ??
    "U"
  ).toUpperCase();

  if (user?.photoURL) { */
  function Avatar({ user, profile, size = 36 }) {
    const photoURL = profile?.photoURL || user?.photoURL || "";
    const initial = (
      profile?.displayName?.trim()?.[0] ??
      user?.displayName?.trim()?.[0] ??
      user?.email?.trim()?.[0] ??
      "U"
    ).toUpperCase();

    if (photoURL) {
      return (
        <img
          // src={user.photoURL}
          src={photoURL}
          alt="profile"
          width={size}
          height={size}
          style={{
            borderRadius: "50%",
            objectFit: "cover",
            display: "block",
          }}
        />
      );
  }

  return (
    <div
      aria-label="profile-initial"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        lineHeight: 1,
        fontSize: size * 0.5,
        background: "#e9ecef",
        color: "#212529",
        fontWeight: 600,
        fontFamily: "Kanit, system-ui, -apple-system, Segoe UI, Roboto",
        userSelect: "none",
      }}
    >
      {initial}
    </div>
  );
}

function Header() {
  const navigate = useNavigate();
  const { user, profile, logout } = useAuth();
  const role = profile?.role || "user"; // ค่า default เป็น user

  const [showMyArticleNotlogin, setShowMyArticleNotlogin] = useState(false);
  const handleCloseMyArticleNotlogin = () => setShowMyArticleNotlogin(false);

  const [searchText, setSearchText] = useState("");

  // === คุมการเปิด/ปิด Offcanvas (เมนูมือถือ) ===
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const q = searchText.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const aiSubs = [
    "AI Fundamentals",
    "AI for Productivity",
    "AI Automation",
    "AI for Developers",
    "AI for Creatives",
  ];

  return (
    <div>
      <Navbar expand="lg" className="mb-3 header-navbar">
        <Container className="header-container-mobile">
          {/* แถวแรก: โลโก้ + เมนู Toggle */}
          <div className="header-row-top d-flex align-items-center">
            <Navbar.Brand href="/" className="logo-brand">
              <img
                src={Logo_Header_02}
                width="130"
                height="auto"
                alt="Encraft Logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle
              className="menu-toggle-mobile d-lg-none ms-auto"
              onClick={() => setShowOffcanvas(true)} // เปิด Offcanvas
            />
          </div>

          {/* แถวที่สอง: ช่องค้นหาเต็มแถว */}
          <Form
            className="header-search-mobile d-lg-none w-100 mt-2"
            onSubmit={handleSearchSubmit}
          >
            <div className="header-search-box-mobile">
              <span className="header-search-icon">
                <BsSearch />
              </span>
              <input
                type="search"
                className="form-control header-search-input"
                placeholder="ค้นหาบทความใน Encraft"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                enterKeyHint="search"   // ⭐ ปุ่ม Return → Search
              />
            </div>
          </Form>

          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="end"
            show={showOffcanvas} // ใช้ state
            onHide={() => setShowOffcanvas(false)} // ปิดเมื่อกด X หรือ backdrop
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title
                id={`offcanvasNavbarLabel-expand-lg`}
                style={{ fontFamily: "Kanit" }}
              >
                <Link 
                  to="/"
                  onClick={() => setShowOffcanvas(false)}
                  style={{
                    textDecoration: "none",
                    color: "inherit"  // ทำให้สีเหมือนเดิม
                  }}
                >
                  Encraft.org
                </Link>
              </Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="header-offcanvas-body">
              {/* ====== Desktop layout (≥ lg) ====== */}
              <div className="d-none d-lg-flex flex-grow-1 align-items-center">
                {/* เมนูหลัก (desktop) */}
                <Nav className="nav-menu d-flex align-items-center">
                  <NavDropdown
                    className="rounded-0 nav-article-btn"
                    title="ค้นหา"
                    id="collapsible-nav-dropdown"
                    style={{
                      color: "black",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontFamily: "Kanit",
                    }}
                  >
                    {aiSubs.map((item) => (
                      <NavDropdown.Item
                        key={item}
                        onClick={() => {
                          window.location.href = `/search?q=${encodeURIComponent(
                            item
                          )}`;
                        }}
                      >
                        {item}
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>

                  {/* ช่องค้นหา – version จอใหญ่ */}
                  <Form
                    className="header-search d-none d-md-flex ms-3"
                    onSubmit={handleSearchSubmit}
                  >
                    <div className="header-search-box">
                      <span className="header-search-icon">
                        <BsSearch />
                      </span>
                      <input
                        type="search"
                        className="form-control header-search-input"
                        placeholder="ค้นหาบทความใน Encraft"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                  </Form>
                </Nav>

                {/* โปรไฟล์ / ปุ่มล็อกอิน (desktop) */}
             
              </div>

              {/* ====== Mobile layout (< lg) ====== */}
              <div className="d-lg-none w-100">
                <Nav className="flex-column w-100 nav-menu nav-menu-mobile">
                  <div className="menu-section-label mb-2" style={{fontWeight: "bold"}}>ค้นหาจาก</div>

                  {/* 1) ลิสต์หมวดหมู่จาก aiSubs */}
                  {aiSubs.map((item) => (
                    <Nav.Link
                      key={item}
                      className="navlink-with-arrow py-1"
                      onClick={() => {
                        setShowOffcanvas(false);
                        navigate(`/search?q=${encodeURIComponent(item)}`);
                        // หรือถ้าอยากใช้แบบ reload หน้า:
                        // window.location.href = `/search?q=${encodeURIComponent(item)}`;
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between w-100">
                        <span>{item}</span>
                        <BsChevronRight size={18} className="text-muted" />
                      </div>
                    </Nav.Link>
                  ))}
                  
                  
               

               
                </Nav>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      <Modal
        show={showMyArticleNotlogin}
        onHide={handleCloseMyArticleNotlogin}
        animation={false}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title>เข้าสู่ระบบ/สมัครสมาชิก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Link
            to="/login"
            onClick={() => setShowMyArticleNotlogin(false)}
            style={{ textDecoration: "none" }}
          >
            เข้าระบบ
          </Link>{" "}
          หรือ{" "}
          <Link
            to="/register"
            onClick={() => setShowMyArticleNotlogin(false)}
            style={{ textDecoration: "none" }}
          >
            สมัครสมาชิก
          </Link>{" "}
          เพื่อใช้งานบทความของฉัน
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMyArticleNotlogin}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Header;

